import { connectionLabelFromFindingRow } from './findingLabels';

/** Matches backend {@link InvestigationService#COMMON_LINK_LABEL}. */
export const COMMON_MAP_LINK_LABEL = 'Common link identified';

export function normalizeMapTarget(value) {
  return value == null ? '' : String(value).trim().toLowerCase();
}

export function normalizeMapLinkLabel(label) {
  const t = label == null ? '' : String(label).trim();
  return t || COMMON_MAP_LINK_LABEL;
}

export function investigationForMapTarget(caseInvestigations, target) {
  const key = normalizeMapTarget(target);
  if (!key) return null;
  return (caseInvestigations || []).find((inv) => normalizeMapTarget(inv.targetValue) === key) ?? null;
}

export function graphLinkExists(caseGraphLinks, sourceId, targetId, label) {
  if (!sourceId || !targetId) return false;
  const want = normalizeMapLinkLabel(label).toLowerCase();
  return (caseGraphLinks || []).some(
    (gl) =>
      gl.sourceInvestigationId === sourceId
      && gl.targetInvestigationId === targetId
      && normalizeMapLinkLabel(gl.label).toLowerCase() === want,
  );
}

/**
 * Whether the grey “add to map” action should show for a manual finding row.
 * Same target may appear under multiple categories; each distinct edge label can be linked once.
 */
export function canShowAddFindingToMap({
  finding,
  investigationId,
  caseInvestigations,
  caseGraphLinks,
}) {
  const target = finding?.informationValue != null ? String(finding.informationValue).trim() : '';
  if (!target || !investigationId) return false;

  const label = connectionLabelFromFindingRow(finding);
  const inv = investigationForMapTarget(caseInvestigations, target);
  if (!inv) return true;

  if (inv.parentInvestigationId === investigationId) {
    if (
      normalizeMapLinkLabel(inv.connectionLabel).toLowerCase()
      === normalizeMapLinkLabel(label).toLowerCase()
    ) {
      return false;
    }
    return !graphLinkExists(caseGraphLinks, investigationId, inv.id, label);
  }

  return !graphLinkExists(caseGraphLinks, investigationId, inv.id, label);
}
